export const CopyIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.83325 4.14395V2.60425C4.83325 2.08648 5.25299 1.66675 5.77075 1.66675H13.8958C14.4135 1.66675 14.8333 2.08648 14.8333 2.60425V10.7292C14.8333 11.247 14.4135 11.6667 13.8958 11.6667H12.3387"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
    <path
      d="M11.2292 4.33325H3.10425C2.58648 4.33325 2.16675 4.75299 2.16675 5.27075V13.3958C2.16675 13.9135 2.58648 14.3333 3.10425 14.3333H11.2292C11.747 14.3333 12.1667 13.9135 12.1667 13.3958V5.27075C12.1667 4.75299 11.747 4.33325 11.2292 4.33325Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.2"
    />
  </svg>
);
